import React, { useState, useEffect } from "react";
import Grid from "../Grid/Grid";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import DropDownGrid from "../Grid/Components/DropDownGrid";
import {
  Box,
  MenuItem,
  ListItemIcon,
  Tooltip,
  Typography,
  IconButton,
  Chip
} from "@mui/material";
import Cookies from "universal-cookie";
import { useNavigate, useLocation } from "react-router-dom";

import Search from "./Search";
import useFilterVisibility from "../PrivateFilters/useFilterVisibility";
import transactionAPI from "../../Network/Transaction";
import arrivalValidityRuleAPI from "../../Network/ArrivalValidityRule";
import arrivalValidityLogAPI from "../../Network/ArrivalValidityLog";
import RecalcValidityDialog from "./RecalcValidityDialog";
import ArrivalDurationsModal from "./ArrivalDurationsModal";
import { ARRIVAL_VALIDITY_ENABLED } from "../../featureFlags";
import FormContainer from "./Form/FormContainer";
import Title from "./Title";
import { selectRoles } from "../../reduxStore/RolesReducer";
import CustomToggleStatus from "../../Components/CustomToggleStatus";
import CustomLargeTextView from "../../Components/CustomLargeTextView";
import DownloadIcon from '@mui/icons-material/Download';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import RouteIcon from '@mui/icons-material/Route';
import ViewFormContainer from "./ViewForm/ViewFormContainer";
import moment from "moment";
import branchAPI from "../../Network/Branch";
import swal from "sweetalert";
import CancelIcon from '@mui/icons-material/Cancel';
import UpdateFormContainer from "./UpdateForm/UpdateFormContainer";
import FlagIcon from '@mui/icons-material/Flag';
import EditIcon from "@mui/icons-material/Edit";
import helpers from "../../assets/js/helper";
import { selectTransactionFilter, setTransactionFilters } from "../../reduxStore/SettingsReducer";
import transactionStatusAPI from "../../Network/TransactionStatus";
import AuditFormContainer from "./AuditForm/AuditFormContainer";
import VerifiedIcon from '@mui/icons-material/Verified';
import AddRoadIcon from '@mui/icons-material/AddRoad';
import CreateRouteFormContainer from "../Routes/Form/FormContainer"
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AdjustIcon from '@mui/icons-material/Adjust';
import TransactionStops from "./TransactionStops/TransactionStops";
import TransactionRoutes from "./TransactionRoutes/TransactionRoutes";
import CustomMultiStatusIcon from "../../Components/CustomMultiStatusIcon";
import TransactionImagesModal from "../../Components/TransactionImagesModal";
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';


import { SiMicrosoftexcel } from 'react-icons/si'
import { BsFilePdfFill } from 'react-icons/bs'
import CustomDataGrid from "../../Components/CustomDataGrid/CustomDataGrid";
import CustomDataGridWithSearch from "../../Components/CustomDataGrid/CustomDataGridWithSearch";
import userAPI from "../../Network/User";
import portCategoryAPI from "../../Network/PortCategory";
import municipalityAPI from "../../Network/Municipality";

const cookies = new Cookies();

const todayStart = new Date();
const yesterday = new Date(todayStart);
yesterday.setDate(yesterday.getDate() - 1);
yesterday.setHours(0, 0, 0, 0);

const todayEnd = new Date();
todayEnd.setHours(23, 59, 59, 999);
export default function TransactionsCustom(props) {
  const [t] = useTranslation("common");
  const systemSettings = useSelector((state) => state.systemSettings);
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(false);
  const [openRecalcValidity, setOpenRecalcValidity] = useState(false);
  const [openDurations, setOpenDurations] = useState(false);
  const transactionFilters = useSelector(selectTransactionFilter)
  const [branches, setBranches] = useState([])
  const [loadingBranches, setLoadingBranches] = useState(true)
  const [portCategories, setPortCategories] = useState([])
  const [loadingPortCategories, setLoadingPortCategories] = useState(true)
  const [groups, setGroups] = useState([])
  const [loadingGroups, setLoadingGroups] = useState(true)
  const [fast, setFast] = useState(1)

  const [transactionStatuses, setTransactionStatuses] = useState([])
  const [loadingTransactionStatuses, setLoadingTransactionStatuses] = useState(true)

  const [users, setUsers] = useState([])
  const [loadingUsers, setLoadingUsers] = useState(true)

  const [transactionType2List, setTransactionType2List] = useState([])
  const [loadingTransactionType2List, setloadingTransactionType2List] = useState(true)

  const [transactionProductTypes, setTransactionProductTypes] = useState([])
  const [loadingTransactionProductTypes, setLoadingTransactionProductTypes] = useState(true)

  const [municipalities, setMunicipalities] = useState([])
  const [loadingMunicipalities, setLoadingMunicipalities] = useState(true)

  const [openFilterColumn, setOpenFilterColumn] = useState(false);
  const [openFilterColumnValue, setOpenFilterColumnValue] = useState([]);
  const [elementClicked, setElementClicked] = useState(null);

  const [filters, setFilters] = useState({
    unit: null,
    unit_id: "",
    sourceGeofence: null,
    source_geofence_id: "",
    hostingSourceGeofence: null,
    hosting_source_geofence_id: "",
    destinationGeofence: null,
    destination_geofence_id: "",
    route: null,
    route_id: "",
    creation_date_from: moment().subtract(1, "day").startOf("day").format('YYYY-MM-DD') + " 00:00:00",
    creation_date_to: moment().endOf('day').format('YYYY-MM-DD') + " 23:59:59",
    creationDateFrom: yesterday,
    creationDateTo: todayEnd,
    export_excel: false,
    export_pdf: false,
    note: "",
    arrived_at_from: moment().subtract(1, "day").startOf("day").format('YYYY-MM-DD') + " 00:00:00",
    arrived_at_to: moment().endOf('day').format('YYYY-MM-DD') + " 23:59:59",
    arrivedAtFrom: yesterday,
    arrivedAtTo: todayEnd,
    all_time_arrived_at: 1,
    destination_geofence_name: "",
    source_geofence_name: "",
    municipality: null,
    municipality_id: "",
    all_time: 0,
    is_governmental: null,
    groups_selected: [],
    group_ids: [],
    lifecycle_type: 1,  // Default to external transactions (خارجي)
    audited_by_type: 'all',
    min_weight: "",
    max_weight: ""
  })
  const [reload, setReload] = useState(false)

  const [openForm, setOpenForm] = useState(false);
  const [openViewForm, setOpenViewForm] = useState(false);
  const [openUpdateForm, setOpenUpdateForm] = useState(false);
  const [openAuditForm, setOpenAuditForm] = useState(false)
  const [openCreateRouteForm, setOpenCreateRouteForm] = useState(false)
  const [selectedObject, setselectedObject] = useState(null);
  const [showStops, setShowStops] = useState(false)
  const [showRoutes, setShowRoutes] = useState(false)
  const [showImagesModal, setShowImagesModal] = useState(false)
  const [selectedTransactionForImages, setSelectedTransactionForImages] = useState(null)
  const [transactionDatetime, setTransactionDatetime] = useState(null)

  const handlePageChange = (newPage) => {
    setPageNumber(newPage + 1);
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const controller = new AbortController();

  const [rowsTotal, setRowsTotal] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const screenwidth = useSelector((state) => state.settingsData.screenwidth);
  const [totalWeight, setTotalWeight] = useState(null);

  const rolesRedux = useSelector(selectRoles)
  const [ClickedCollapse, setClickedCollapsed] = useState(null)

  const [columns, setColumns] = useState([
    { headerName: "ت", sx: { flex: 0.1, marginRight: '5px' } },
    { headerName: "ارقام المستند", },
    
    { headerName: "المعلومات الاساسية" },
    { headerName: "البلدية", },
    { field: 'source_geofence_name', headerName: "الميزان", },
    { headerName: "الوزن (طن) ", },
    {
      headerName: "معلومات المراقبة",
      // Per-indicator hide/show. FilterColumn renders an indented sub-checkbox
      // for each entry; DataGridRow gates the matching cell on
      // !column.hideSubIndicators[key]. Persisted alongside `hide` in localStorage.
      subIndicators: [
        { key: 'routes_count',  i18nKey: 'TRANSACTIONS.routes_count' },
        { key: 'is_monitored',  i18nKey: 'TRANSACTIONS.is_monitored' },
        { key: 'has_violation', i18nKey: 'TRANSACTIONS.doesnt_has_violation' },
        { key: 'is_arrived',    i18nKey: 'TRANSACTIONS.is_arrived' },
        { key: 'is_complete',   i18nKey: 'TRANSACTIONS.is_complete_grid_title' },
        { key: 'stop_violation',i18nKey: 'TRANSACTIONS.stop_violation_counter' },
        { key: 'arrival_valid', i18nKey: 'TRANSACTIONS.arrival_valid' },
      ],
      // Default visible: is_monitored, is_arrived, stop_violation.
      // Default hidden:  routes_count, has_violation, is_complete.
      // Users can flip any of these from the show/hide columns popup.
      hideSubIndicators: {
        routes_count:  true,
        has_violation: true,
        is_complete:   true,
      },
      renderHeader: (column) => {
        // Each icon below mirrors a sub-indicator cell in DataGridRow and is
        // gated on the same hideSubIndicators[key] flag, so the header stays
        // in sync with what's actually rendered in the rows.
        const hidden = column?.hideSubIndicators || {};
        return (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flex: 1.5,
              flexDirection: 'row-reverse'
            }}
          >
            {!hidden.routes_count && (
              <Tooltip
                sx={{
                  borderWidth: '3px',
                  borderColor: '#FFFFFF',
                  borderStyle: 'solid',
                  borderRadius: '50%',
                  marginRight: '5px'
                }}
                title={
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {t("TRANSACTIONS.routes_count")}
                  </span>
                }
              >
                <RouteIcon />
              </Tooltip>
            )}
            {!hidden.is_monitored && (
              <Tooltip
                sx={{
                  marginRight: '5px'
                }}
                title={
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {t("TRANSACTIONS.is_monitored")}
                  </span>
                }
              >
                <VisibilityIcon />
              </Tooltip>
            )}
            {!hidden.has_violation && (
              <Tooltip
                sx={{
                  marginRight: '5px'
                }}
                title={
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {t("TRANSACTIONS.doesnt_has_violation")}
                  </span>
                }
              >
                <ThumbUpAltIcon />
              </Tooltip>
            )}
            {!hidden.is_arrived && (
              <Tooltip
                sx={{
                  marginRight: '5px'
                }}
                title={
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {t("TRANSACTIONS.is_arrived")}
                  </span>
                }
              >
                <FlagIcon />
              </Tooltip>
            )}
            {!hidden.is_complete && (
              <Tooltip
                sx={{
                  marginRight: '5px'
                }}
                title={
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {t("TRANSACTIONS.is_complete_grid_title")}
                  </span>
                }
              >
                <CheckCircleIcon />
              </Tooltip>
            )}
            {!hidden.stop_violation && (
              <Tooltip
                sx={{
                  borderWidth: '3px',
                  borderColor: '#FFFFFF',
                  borderStyle: 'solid',
                  borderRadius: '50%'
                }}
                title={
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {t("TRANSACTIONS.stop_violation_counter")}
                  </span>
                }
              >
                <LocalParkingIcon />
              </Tooltip>
            )}
            {!hidden.arrival_valid && (
              <Tooltip
                sx={{ marginRight: '5px', marginLeft: '5px' }}
                title={
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {t("TRANSACTIONS.arrival_valid")}
                  </span>
                }
              >
                <AccessTimeIcon />
              </Tooltip>
            )}
          </Box>
        );
      },


    },

    {
      headerName: "تواقيت المستند",
      sx: { flex: 1.5 }
    },
    {
      headerName: "حالة التدقيق"
    },
    // "المركبة متابعة من قبل" column intentionally omitted on the external
    // (custom) page. The shared DataGridRow cell is gated on isColumnDefined,
    // so removing it here hides both the header and the cell here only.

  ])

  const showUpdate = (has_update_role, transaction) => {

    return (
      has_update_role
      && !transaction?.destination_geofence_name
      && transaction?.enabled
      // && helpers.durationFromNow(transaction?.formatted_datetime, 30)
    )

  }
  const getRowClassName = (params) => {
    if (params?.row?.enabled === 0) {
      return 'highlighted-disabled-row'
    }
    else {
      if (params?.row?.transaction_status_id === 2) {
        return 'highlighted-auditing-row'
      }
      else if (params?.row?.transaction_status_id === 3) {
        return 'highlighted-invalid-row'
      }
      else if (params?.row?.transaction_status_id === 4) {
        return 'highlighted-valid-row'
      }
      else {
        return ''
      }
    }



  };

  const getResources = () => {
    portCategoryAPI.getPortCategoryList({
      params: {
        ...headerObject,
      }

    }).then(portCategoriesResult => {
      if (portCategoriesResult.status && portCategoriesResult?.data?.data) {
        setPortCategories(portCategoriesResult?.data?.data)
      }
      setLoadingPortCategories(false);
    }).catch(error => {
      console.log(error);
      setLoadingPortCategories(false);
    }).finally(() => {
      setLoadingPortCategories(false);
    })

    branchAPI.getBranchList({
      params: {
        ...headerObject,
      }

    }).then(branchesResult => {
      if (branchesResult.status && branchesResult?.data?.data) {
        setBranches(branchesResult?.data?.data)
      }
      setLoadingBranches(false);
    }).catch(error => {
      console.log(error);
      setLoadingBranches(false);
    }).finally(() => {
      setLoadingBranches(false);
    })

    transactionStatusAPI.getTransactionStatusList({
      params: {
        ...headerObject,
      }

    }).then(transactionStatusesResult => {
      if (transactionStatusesResult.status && transactionStatusesResult?.data?.data) {
        setTransactionStatuses(transactionStatusesResult?.data?.data)
      }
      setLoadingTransactionStatuses(false);
    }).catch(error => {
      console.log(error);
      setLoadingTransactionStatuses(false);
    }).finally(() => {
      setLoadingTransactionStatuses(false);
    })
    userAPI.getUserList({
      params: {
        ...headerObject,
      }

    }).then(usersResult => {
      if (usersResult.status && usersResult?.data?.data) {
        setUsers(usersResult?.data?.data)
      }
      setLoadingUsers(false);
    }).catch(error => {
      console.log(error);
      setLoadingUsers(false);
    }).finally(() => {
      setLoadingUsers(false);
    })

    transactionAPI.getTransactionType2List({
      params: {
        ...headerObject,
      }

    }).then(tt2Result => {

      if (tt2Result.status && tt2Result?.data?.data) {

        setTransactionType2List(tt2Result?.data?.data)
      }
      setloadingTransactionType2List(false);
    }).catch(error => {
      console.log(error);
      setloadingTransactionType2List(false);
    }).finally(() => {
      setloadingTransactionType2List(false);
    })
    transactionAPI.transactionProductTypes({
      params: {
        ...headerObject,
      }

    }).then(transactionProductTypesResult => {
      if (transactionProductTypesResult.status && transactionProductTypesResult?.data?.data) {
        setTransactionProductTypes(transactionProductTypesResult?.data?.data)
      }
      setLoadingTransactionProductTypes(false);
    }).catch(error => {
      console.log(error);
      setLoadingTransactionProductTypes(false);
    }).finally(() => {
      setLoadingTransactionProductTypes(false);
    })


    municipalityAPI.getMunicipalityList({
      params: {
        ...headerObject,
      }

    }).then(municipalityResult => {
      if (municipalityResult.status && municipalityResult?.data?.data) {
        setMunicipalities(municipalityResult?.data?.data)
      }
      setLoadingMunicipalities(false);
    }).catch(error => {
      console.log(error);
      setLoadingMunicipalities(false);
    }).finally(() => {
      setLoadingMunicipalities(false);
    })

    transactionAPI.getUserUnitGroups({
      params: {
        ...headerObject,
      }

    }).then(groupsResult => {
      if (groupsResult.status && Array.isArray(groupsResult?.data?.data)) {
        setGroups(groupsResult?.data?.data)
      }
      setLoadingGroups(false);
    }).catch(error => {
      console.log(error);
      setLoadingGroups(false);
    }).finally(() => {
      setLoadingGroups(false);
    })


  }


  useEffect(() => {
    getResources()
    return () => {

    }
  }, [])

  useEffect(() => {
    if (location.state) {
      const { unit_id, unit_name, creation_date_from, creation_date_to, audited_status } = location.state;
      
      // If we need status filtering, wait for statuses to load
      if (audited_status && audited_status > 0 && (!transactionStatuses || transactionStatuses.length === 0)) {
        return;
      }

      let updatedFilters = {
        ...filters,
        unit: unit_id ? { id: unit_id, name: unit_name } : null,
        unit_id: unit_id || "",
        creation_date_from: creation_date_from || filters.creation_date_from,
        creation_date_to: creation_date_to || filters.creation_date_to,
        creationDateFrom: creation_date_from ? new Date(creation_date_from) : filters.creationDateFrom,
        creationDateTo: creation_date_to ? new Date(creation_date_to) : filters.creationDateTo,
        all_time: creation_date_from ? 0 : 1
      };

      if (audited_status === 2) {
        // Audited: Statuses 2, 3, 4 (Auditing, Invalid, Valid)
        updatedFilters.transaction_status_ids = [2, 3, 4];
        updatedFilters.transaction_status_selected = (transactionStatuses || []).filter(s => [2, 3, 4].includes(s.id));
      } else if (audited_status === 1) {
        // Not Audited: Status 1
        updatedFilters.transaction_status_ids = [1];
        updatedFilters.transaction_status_selected = (transactionStatuses || []).filter(s => s.id === 1);
      }

      setFilters(updatedFilters);
      setReload(!reload);

      // Clear state to avoid re-triggering on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state, transactionStatuses]);

  useEffect(() => {
    const savedState = localStorage.getItem('dashboardFilters');

    if (!savedState) {
      loadData()
    }

  }, [pageNumber, pageSize, reload]);

  useEffect(() => {
    const savedState = localStorage.getItem('dashboardFilters');
    if (savedState) {
      const savedStateJson = JSON.parse(savedState);

      setFilters(prevFilters => ({
        ...prevFilters,
        ...savedStateJson,
        creationDateFrom: savedStateJson?.creationDateFrom ? new Date(savedStateJson?.creationDateFrom) : prevFilters.creationDateFrom,
        creationDateTo: savedStateJson?.creationDateTo ? new Date(savedStateJson?.creationDateTo) : prevFilters.creationDateTo,
      }));

      localStorage.removeItem('dashboardFilters');

      setTimeout(() => {
        setReload(prev => !prev);
      }, 500);
    }
  }, []);

  // Per-filter visibility for this page. Fetched here (the page stays mounted)
  // so the config is ready before the search drawer opens — no filter flash.
  const { isVisible: filterIsVisible } = useFilterVisibility("transactions_custom");

  const headerObject = {
    username: cookies.get("user_name") ? cookies.get("user_name") : null,
    user_id: cookies.get("user_id") ? cookies.get("user_id") : null,
    account_name: cookies.get("account_name") ? cookies.get("account_name") : null,
    account_id: cookies.get("account_id") ? cookies.get("account_id") : null,
    authHash: cookies.get("authHash") ? cookies.get("authHash") : null,
    sid: cookies.get("sid") ? cookies.get("sid") : null,
    baseurl: cookies.get("baseUrl") ? cookies.get("baseUrl") : null,
    id: cookies.get("id") ? cookies.get("id") : null,
    accessible_accounts_ids: cookies.get("accessible_accounts_ids") ? cookies.get("accessible_accounts_ids") : null,
  }
  const loadData = async (searchParams) => {


    if (
      cookies.get("active_session") &&
      cookies.get("active_session") == "yes"
    ) {
      let object = {
        ...headerObject,
        ...(filters?.export_excel || filters?.export_pdf ? {} :
          {
            page: pageNumber,
            page_size: pageSize,
          }),
        ...(props?.noUnit ? {
          no_unit: 1,
        } : {}),
        search: "",
        ...searchParams,
        ...filters,
        ...(systemSettings?.includePrivateUnits == 1) ? {
          carrier: 1
        } : {},

        fast: fast,
        is_custom_geofence_filter: 1,
        ...((filters?.export_excel || filters?.export_pdf)
          ? { applied_filters: JSON.stringify(buildAppliedFiltersForExport()) }
          : {})
      };

      setLoading(true);

      const result = await transactionAPI.transactions({
        params: object,
        signal: controller?.signal,
      });
      setLoading(false);

      if (result.status && result?.data?.data) {


        if (filters?.export_excel) {
          setFilters({
            ...filters,
            export_excel: false
          })
          downloadExcel(result?.data?.data)
        }
        else if (filters?.export_pdf) {
          setFilters({
            ...filters,
            export_pdf: false
          })
          downloadPDF(result?.data?.data)
        }
        else {
          if (result?.data?.data?.data?.length > 0) {
            setRows(result?.data?.data?.data);
            setRowsTotal(result?.data?.data?.total_records);
            setTotalWeight(result?.data?.data?.total_weight ?? null);
            setPageCount(Math.ceil(result?.data?.data?.total_records / pageSize));
          }
          else {
            setRows([]);
            setRowsTotal(0);
            setTotalWeight(null);
            setPageCount(0);
          }
        }
      } else {

        if (result?.data?.data?.message) {
          toast.error(result?.data?.data?.message?.text ? result?.data?.data?.message?.text : result?.data?.data?.message)
        }
        else if (!result?.data?.error) {
          toast.error(t("NETWORK_MESSAGES.unknownError"));
          return;
        }
        if (result && result?.data && result?.data?.data?.message) {
          if (result?.data?.data?.message?.text == "unauthorized to complete") {
            navigate("/redirect");
          }
        }
      }
      setLoading(false);
    } else {
      navigate("/redirect");
    }
  };

  const createRouteFunction = (obj) => {
    setselectedObject(obj)
    setOpenCreateRouteForm(true)
  }

  const auditFunction = (obj) => {
    setselectedObject(obj)
    setOpenAuditForm(true)
  }
  const createFunction = () => {
    setselectedObject(null);
    setOpenForm(true);
  };
  const showStopsFunction = (obj) => {
    setselectedObject(obj)
    setShowStops(true)
  }
  const showRoutesFunction = (obj) => {
    setselectedObject(obj)
    setShowRoutes(true)
  }
  const viewFunction = (obj) => {
    setselectedObject(obj)
    setOpenViewForm(true)
  }
  const UpdateFunction = (obj) => {
    setselectedObject(obj)
    setOpenUpdateForm(true)
  }

  const checkArrivalFunction = async (obj) => {
    swal({
      title: t('GLOBAL.are_you_sure'),
      text: "هل تريد التحقق من وصول المركبة الآن؟",
      icon: 'info',
      buttons: [t('GLOBAL.no'), t('GLOBAL.yes')],
      dangerMode: false,
    }).then(async (approved) => {
      if (!approved) return;
      setLoading(true);
      try {
        const result = await transactionAPI.checkArrival({
          data: { transaction_id: obj?.id },
          params: headerObject
        });
        if (result?.status && result?.data?.status) {
          if (result?.data?.data?.arrived) {
            toast.success(result?.data?.data?.message_text || "تم تأكيد وصول المركبة");
            setReload(!reload);
          } else {
            toast.info(result?.data?.data?.message_text || "لم يتم تسجيل وصول للمركبة خلال الفترة الزمنية");
          }
        } else {
          if (result?.data?.data?.message?.text === "unauthorized to complete") {
            navigate("/redirect");
          } else {
            toast.error(result?.data?.data?.message?.text ? result?.data?.data?.message?.text : result?.data?.data?.message);
          }
        }
      } catch (error) {
        toast.error(error?.message);
      } finally {
        setLoading(false);
      }
    });
  };

  // Per-transaction: re-evaluate arrival validity against the current rules and
  // apply the (غير معتمد) audit if the arrival now fails a matching rule.
  const recalcValidityFunction = async (obj) => {
    swal({
      title: t('GLOBAL.are_you_sure'),
      text: "هل تريد إعادة احتساب صلاحية وصول هذا المستند وفق القواعد الحالية؟",
      icon: 'info',
      buttons: [t('GLOBAL.no'), t('GLOBAL.yes')],
      dangerMode: false,
    }).then(async (approved) => {
      if (!approved) return;
      setLoading(true);
      try {
        const result = await arrivalValidityRuleAPI.recomputeArrivalValidity({
          data: { transaction_id: obj?.id },
        });
        if (result?.status && result?.data?.status) {
          const detail = result?.data?.data?.detail;
          console.log("[arrival-validity recompute]", detail);
          if (detail?.applied) {
            toast.success("تم اعتبار وصول المستند غير معتمد (خارج الفترة المسموحة)");
          } else if (detail?.reason === 'no_arrived_at') {
            toast.warning("لا يوجد وقت وصول مسجل لهذا المستند");
          } else if (detail?.matched === false || detail?.reason === 'no_match') {
            toast.info("لا توجد قاعدة مطابقة لهذا المستند (تحقق من النوع ومنطقة الوصول والفترة)");
          } else {
            toast.info("الوصول ضمن الفترة المسموحة - لا يوجد تغيير");
          }
          setReload(!reload);
        } else {
          const m = result?.data?.data?.message;
          toast.error((typeof m === "string" ? m : m?.text) || t("NETWORK_MESSAGES.unknownError"));
        }
      } catch (error) {
        toast.error(error?.message);
      } finally {
        setLoading(false);
      }
    });
  };

  // Per-transaction: revert the arrival-validity status change, restoring the
  // document to the status it had before the check.
  const revertValidityFunction = async (obj) => {
    swal({
      title: t('GLOBAL.are_you_sure'),
      text: "هل تريد التراجع عن تدقيق صلاحية الوصول واستعادة حالة المستند السابقة؟",
      icon: 'warning',
      buttons: [t('GLOBAL.no'), t('GLOBAL.yes')],
      dangerMode: true,
    }).then(async (approved) => {
      if (!approved) return;
      setLoading(true);
      try {
        const result = await arrivalValidityLogAPI.revertArrivalValidity({
          data: { transaction_id: obj?.id },
        });
        if (result?.status && result?.data?.status) {
          toast.success(result?.data?.data?.message || "تم التراجع بنجاح");
          setReload(!reload);
        } else {
          const m = result?.data?.data?.message;
          toast.error((typeof m === "string" ? m : m?.text) || t("NETWORK_MESSAGES.unknownError"));
        }
      } catch (error) {
        toast.error(error?.message);
      } finally {
        setLoading(false);
      }
    });
  };

  const handleReprocessWrongType = async () => {
    swal({
      title: t('GLOBAL.are_you_sure'),
      text: "هل انت متأكد من انك تريد اعادة معالجة الحركات التي تم تسجيلها بنوع حركة خاطئ؟",
      icon: 'info',
      buttons: [t('GLOBAL.no'), t('GLOBAL.yes')],
      dangerMode: true,
    }).then(async (approved) => {
      if (approved) {
        setLoading(true);
        try {
          const result = await transactionAPI.reprocessWrongType({
            params: headerObject
          });
          
          if (result?.status && result?.data?.status) {
            swal("بدأت المعالجة في الخلفية", result?.data?.data?.message, "success");
            setReload(!reload); 
          } else {
            if (result?.data?.data?.message?.text == "unauthorized to complete") {
              navigate("/redirect");
            } else {
              toast.error(result?.data?.data?.message?.text ? result?.data?.data?.message?.text : result?.data?.data?.message);
            }
          }
        } catch (error) {
          toast.error(error.message);
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const showImagesFunction = (transaction) => {
    setSelectedTransactionForImages(transaction?.pending_transaction_id);
    setTransactionDatetime(transaction?.formatted_datetime);
    setShowImagesModal(true);
  };
  const exportReport = (object) => {
    confirmExportReport(object)

    // swal({
    //   title: t('GLOBAL.are_you_sure'),
    //   text: t('TRANSACTIONS.start_export_report'),
    //   icon: 'info',
    //   buttons: [t('GLOBAL.no'), t('GLOBAL.yes')],
    //   dangerMode: true,
    // }).then(async (updateWithWialonLink) => {

    //   if (updateWithWialonLink) {
    //     confirmExportReport(object)
    //   } else {
    //     // alert('canceled')
    //   }
    // })


  }

  const createReport = async (object) => {
    setLoading(true)
    let readyToSendObject = {}

    let params = {
      ...headerObject
    };

    let result = null;
    if (object && object?.id) {
      readyToSendObject["transaction_id"] = object?.id;

      try {
        result = await transactionAPI.addCreatedgReport({
          data: readyToSendObject,
          params: params,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });
        if (result?.status && result?.data?.status) {
          toast.success("تم انشاء تقرير")
          setLoading(false)
        } else {

          if (result?.data?.data?.message?.text == "unauthorized to complete") {
            navigate("/redirect");
          }

          else {
            setLoading(false)
            toast.error(result?.data?.data?.message?.text ? result?.data?.data?.message?.text : result?.data?.data?.message)
          }
        }

      } catch (error) {
        setLoading(false)

        toast.error(error.message);
      }
    }
    setLoading(false)
  }

  const confirmExportReport = async (object) => {
    setLoading(true)
    let readyToSendObject = {}

    let params = {
      ...headerObject
    };

    let result = null;
    if (object && object?.id) {
      readyToSendObject["transaction_id"] = object?.id;

      try {
        result = await transactionAPI.addPenddingReport({
          data: readyToSendObject,
          params: params,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });
        if (result?.status && result?.data?.status) {




          const fileResult = await transactionAPI.downloadPenddingReport({
            params: {
              ...params,
              pending_transaction_report_id: result?.data?.data?.id
            }
          })

          if (fileResult?.status && fileResult?.data?.status) {

            downloadPDF(fileResult?.data?.data?.report_path, object)
          }
          else {
            toast.error(fileResult?.data?.data?.message?.text ? fileResult?.data?.data?.message?.text : fileResult?.data?.data?.message)
            setLoading(false)
          }


        } else {


          if (result?.data?.data?.message?.text == "unauthorized to complete") {
            navigate("/redirect");
          }

          else {

            toast.error(result?.data?.data?.message?.text ? result?.data?.data?.message?.text : result?.data?.data?.message)
          }
        }

      } catch (error) {
        setLoading(false)

        toast.error(error.message);
      }
    }
  }
  // Filename date suffix = the active filter's creation-date range (dates only).
  // Falls back to the current date when no range is set (e.g. all-time filter)
  // so the name is never empty.
  const getExportDateSuffix = () => {
    const fmt = 'YYYY-MM-DD';
    if (filters?.creation_date_from && filters?.creation_date_to) {
      return `${moment(filters.creation_date_from).format(fmt)} - ${moment(filters.creation_date_to).format(fmt)}`;
    }
    return moment().format(fmt);
  };

  const downloadPDF = async (fileName, transaction) => {
    const result = await transactionAPI.downloadTransactionPdf({
      params: {
        ...headerObject,
        fileName: fileName
      }
    })
    setLoading(false)
    if (result.status && result?.data) {
      const url = window.URL.createObjectURL(new Blob([result?.data]));
      const link = document.createElement('a');
      link.href = url;
      
      let reportName = "";
      if (transaction) {
        reportName = ` (${transaction?.transaction_number ? transaction?.transaction_number : " 000"}) حسب المستند  (${transaction?.unit_name ? transaction?.unit_name : ""}) مراقبة المركبة `;
      } else {
        reportName = "مستندات الجهد الخارجي";
        if (filters.municipality && filters.municipality.name) {
          reportName += ` - ${filters.municipality.name}`;
        }
        reportName += ` - ${getExportDateSuffix()}`;
      }

      // BE returns "<name>_0.pdf" for a single chunk or "<name>.zip" when chunks were zipped.
      const isZip = typeof fileName === 'string' && fileName.toLowerCase().endsWith('.zip');
      link.setAttribute('download', reportName + (isZip ? '.zip' : '.pdf'));
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Clean up the URL object
      window.URL.revokeObjectURL(url);
    }

  }
  const exportFunction = () => {

    setFilters({
      ...filters,
      export_excel: true
    })
    setReload(!reload)
  }
  const exportPDF = () => {
    setFilters({
      ...filters,
      export_pdf: true
    })
    setReload(!reload)
  }

  const clearFilterFunction = () => {
    setFilters({
      name: "",
      code: "",
      transaction_id: "",
      transaction_number: "",
      type_id: null,
      wialon_id: null,
      export_excel: false,
      export_pdf: false,
      creation_date_from: moment().subtract(1, "day").startOf("day").format('YYYY-MM-DD') + " 00:00:00",
      creation_date_to: moment().endOf('day').format('YYYY-MM-DD') + " 23:59:59",
      creationDateFrom: yesterday,
      creationDateTo: todayEnd,
      arrived_at_from: moment().subtract(1, "day").startOf("day").format('YYYY-MM-DD') + " 00:00:00",
      arrived_at_to: moment().endOf('day').format('YYYY-MM-DD') + " 23:59:59",
      arrivedAtFrom: yesterday,
      arrivedAtTo: todayEnd,
      export_excel: false,
      note: "",
      destination_geofence_name: "",
      source_geofence_name: "",
      all_time: 0,
      all_time_arrived_at: 1,
      is_governmental: null,
      groups_selected: [],
      group_ids: [],
      lifecycle_type: 1,  // Keep external filter when clearing
      destination_mismatch: -1,
      audited_by_type: 'all',
      min_weight: "",
      max_weight: ""
    })
  }
  const searchFunction = () => {
    setReload(!reload)
    setPageNumber(1)
  };

  // Flat {label, value} list of the user-visible filters — sent with the export
  // request so the BE can render a "Filters applied" section in the excel.
  const buildAppliedFiltersForExport = () => {
    const out = [];
    if (filters.unit) out.push({ label: "المركبة", value: filters.unit.name || '' });
    if (filters.account) out.push({ label: "العائدية", value: filters.account.name || '' });
    if (filters.is_governmental !== null && filters.is_governmental !== '' && filters.is_governmental !== undefined) {
      out.push({ label: "نوع الجهد", value: String(filters.is_governmental) === '1' ? 'ذاتي' : 'مؤجر' });
    }
    if (filters.municipality) out.push({ label: "البلدية", value: filters.municipality.name || filters.municipality.municipality_name || '' });
    if (filters.mizan_selected) out.push({ label: "الميزان", value: filters.mizan_selected.name || '' });
    if (filters.host_mizan_selected) out.push({ label: "الميزان المستضاف", value: filters.host_mizan_selected.name || '' });
    if (filters.unit_type_selected) out.push({ label: "نوع المركبة", value: filters.unit_type_selected.name || '' });
    if (Array.isArray(filters.port_categories_selected) && filters.port_categories_selected.length > 0) {
      out.push({ label: "صنف نقطة التفريغ", value: filters.port_categories_selected.map(p => p?.name).filter(Boolean).join('، ') });
    }
    if (Array.isArray(filters.groups_selected) && filters.groups_selected.length > 0) {
      out.push({ label: "المجاميع", value: filters.groups_selected.map(g => g?.name).filter(Boolean).join('، ') });
    }
    if (filters.sourceGeofence) out.push({ label: "نقطة التحميل", value: filters.sourceGeofence.name || '' });
    if (filters.hostingSourceGeofence) out.push({ label: "نقطة التحميل المستضافة", value: filters.hostingSourceGeofence.name || '' });
    if (filters.destinationGeofence) out.push({ label: "نقطة التفريغ", value: filters.destinationGeofence.name || '' });
    if (filters.route) out.push({ label: "المسار", value: filters.route.name || '' });
    if (filters.productType) out.push({ label: "نوع الحمولة", value: filters.productType.name || filters.productType.product_type || '' });
    if (filters.unit_monitored_by_id_selected) out.push({ label: "المراقب", value: filters.unit_monitored_by_id_selected.name || '' });
    if (filters.auditedByName) out.push({ label: "المدقق", value: filters.auditedByName.name || filters.auditedByName });
    if (Array.isArray(filters.transaction_status_selected) && filters.transaction_status_selected.length > 0) {
      out.push({ label: "حالة التدقيق", value: filters.transaction_status_selected.map(s => s?.name).filter(Boolean).join('، ') });
    }
    if (Array.isArray(filters.branches_selected) && filters.branches_selected.length > 0) {
      out.push({ label: "الفروع", value: filters.branches_selected.map(b => b?.name).filter(Boolean).join('، ') });
    }

    const textPairs = [
      ['transaction_id', 'رقم المعاملة'],
      ['transaction_number', 'رقم المستند'],
      ['unit_registration_number', 'رقم اللوحة'],
      ['driver_name', 'السائق'],
      ['destination_warehouse', 'خزان الوصول'],
      ['note', 'ملاحظة'],
    ];
    textPairs.forEach(([key, label]) => {
      const v = filters[key];
      if (v !== null && v !== undefined && String(v).trim() !== '') out.push({ label, value: String(v) });
    });

    if (String(filters.min_weight ?? '').trim() !== '' || String(filters.max_weight ?? '').trim() !== '') {
      const minLabel = String(filters.min_weight ?? '').trim() !== '' ? filters.min_weight : '—';
      const maxLabel = String(filters.max_weight ?? '').trim() !== '' ? filters.max_weight : '—';
      out.push({ label: 'الوزن (طن)', value: `من ${minLabel} إلى ${maxLabel}` });
    }

    const triPairs = [
      ['unit_is_monitored', 'مركبة مراقبة', 'مركبة غير مراقبة'],
      ['is_monitored', 'مستند مراقب', 'مستند غير مراقب'],
      ['has_violation', 'فيه مخالفة', 'بدون مخالفة'],
      ['is_complete', 'مكتمل', 'غير مكتمل'],
      ['exceeded_allowed_time', 'تجاوز الزمن المسموح', 'لم يتجاوز الزمن المسموح'],
      ['has_stop_violation', 'يوجد توقف مخالف', 'بدون توقف مخالف'],
      ['weight_problem', 'يوجد مشكلة بالوزن', 'بدون مشكلة بالوزن'],
      ['destination_mismatch', 'اختلاف نقطة التفريغ', 'مطابقة نقطة التفريغ'],
      ['valid', 'صالح', 'غير صالح'],
      ['arrival_validity', 'وصل ضمن الفترة المسموحة', 'وصل خارج الفترة المسموحة'],
    ];
    triPairs.forEach(([key, on, off]) => {
      const s = String(filters[key]);
      if (s === '1') out.push({ label: '—', value: on });
      else if (s === '0') out.push({ label: '—', value: off });
    });

    if (filters.audited_by_type === 'system') out.push({ label: 'جهة التدقيق', value: 'النظام' });
    else if (filters.audited_by_type === 'user') out.push({ label: 'جهة التدقيق', value: 'المستخدمين' });

    if (Number(filters.all_time) === 1) {
      out.push({ label: 'الفترة', value: 'كل الوقت' });
    } else if (filters.creation_date_from || filters.creation_date_to) {
      const fromLabel = filters.creation_date_from ? moment(filters.creation_date_from).format('YYYY-MM-DD HH:mm') : '—';
      const toLabel = filters.creation_date_to ? moment(filters.creation_date_to).format('YYYY-MM-DD HH:mm') : '—';
      out.push({ label: 'الفترة', value: `من ${fromLabel} إلى ${toLabel}` });
    }

    if (Number(filters.all_time_arrived_at) !== 1
        && (filters.arrived_at_date_from || filters.arrived_at_date_to
            || filters.arrived_at_from || filters.arrived_at_to)) {
      const fromVal = filters.arrived_at_date_from || filters.arrived_at_from;
      const toVal = filters.arrived_at_date_to || filters.arrived_at_to;
      const fromLabel = fromVal ? moment(fromVal).format('YYYY-MM-DD HH:mm') : '—';
      const toLabel = toVal ? moment(toVal).format('YYYY-MM-DD HH:mm') : '—';
      out.push({ label: 'تاريخ الوصول', value: `من ${fromLabel} إلى ${toLabel}` });
    }

    return out;
  };

  // Apply a partial patch to filters and immediately re-search.
  const applyFilterChange = (patch) => {
    setFilters(prev => ({ ...prev, ...patch }));
    setPageNumber(1);
    setReload(prev => !prev);
  };

  const triStateLabel = (val, onLabel, offLabel) => {
    const s = String(val);
    if (s === '1') return onLabel;
    if (s === '0') return offLabel;
    return null;
  };

  const activeFilterChips = (() => {
    const chips = [];

    // ── Entity filters ─────────────────────────────────────────────
    if (filters.unit) chips.push({
      key: 'unit',
      label: `المركبة: ${filters.unit.name || ''}`,
      onDelete: () => applyFilterChange({ unit: null, unit_id: '' })
    });
    if (filters.account) chips.push({
      key: 'account',
      label: `العائدية: ${filters.account.name || ''}`,
      onDelete: () => applyFilterChange({ account: null, search_account_id: null })
    });
    if (filters.is_governmental !== null && filters.is_governmental !== '' && filters.is_governmental !== undefined) {
      chips.push({
        key: 'is_governmental',
        label: `نوع الجهد: ${String(filters.is_governmental) === '1' ? 'ذاتي' : 'مؤجر'}`,
        onDelete: () => applyFilterChange({ is_governmental: null })
      });
    }
    if (filters.municipality) chips.push({
      key: 'municipality',
      label: `البلدية: ${filters.municipality.name || filters.municipality.municipality_name || ''}`,
      onDelete: () => applyFilterChange({ municipality: null, municipality_id: '' })
    });
    if (filters.mizan_selected) chips.push({
      key: 'mizan',
      label: `الميزان: ${filters.mizan_selected.name || ''}`,
      onDelete: () => applyFilterChange({ mizan_selected: null, mizan_id: null })
    });
    if (filters.host_mizan_selected) chips.push({
      key: 'host_mizan',
      label: `الميزان المستضاف: ${filters.host_mizan_selected.name || ''}`,
      onDelete: () => applyFilterChange({ host_mizan_selected: null, host_mizan_id: null })
    });
    if (filters.unit_type_selected) chips.push({
      key: 'unit_type',
      label: `نوع المركبة: ${filters.unit_type_selected.name || ''}`,
      onDelete: () => applyFilterChange({ unit_type_selected: null, unit_type_id: null })
    });
    if (Array.isArray(filters.port_categories_selected) && filters.port_categories_selected.length > 0) {
      filters.port_categories_selected.forEach((pc) => {
        chips.push({
          key: `pc_${pc?.id}`,
          label: `صنف الوصول: ${pc?.name || ''}`,
          onDelete: () => {
            const remaining = filters.port_categories_selected.filter(x => x?.id !== pc?.id);
            applyFilterChange({
              port_categories_selected: remaining,
              destination_port_categories: remaining.map(x => x.id),
            });
          }
        });
      });
    }
    if (Array.isArray(filters.groups_selected) && filters.groups_selected.length > 0) {
      filters.groups_selected.forEach((g) => {
        chips.push({
          key: `group_${g?.id}`,
          label: `المجاميع: ${g?.name || ''}`,
          onDelete: () => {
            const remaining = filters.groups_selected.filter(x => x?.id !== g?.id);
            applyFilterChange({
              groups_selected: remaining,
              group_ids: remaining.map(x => x.id),
            });
          }
        });
      });
    }
    if (filters.sourceGeofence) chips.push({
      key: 'source',
      label: `نقطة التحميل: ${filters.sourceGeofence.name || ''}`,
      onDelete: () => applyFilterChange({ sourceGeofence: null, source_geofence_id: '' })
    });
    if (filters.hostingSourceGeofence) chips.push({
      key: 'hosting_source',
      label: `نقطة التحميل المستضافة: ${filters.hostingSourceGeofence.name || ''}`,
      onDelete: () => applyFilterChange({ hostingSourceGeofence: null, hosting_source_geofence_id: '' })
    });
    if (filters.destinationGeofence) chips.push({
      key: 'destination',
      label: `نقطة التفريغ: ${filters.destinationGeofence.name || ''}`,
      onDelete: () => applyFilterChange({ destinationGeofence: null, destination_geofence_id: '' })
    });
    if (filters.route) chips.push({
      key: 'route',
      label: `المسار: ${filters.route.name || ''}`,
      onDelete: () => applyFilterChange({ route: null, route_id: '' })
    });
    if (filters.productType) chips.push({
      key: 'product_type',
      label: `نوع الحمولة: ${filters.productType.name || filters.productType.product_type || ''}`,
      onDelete: () => applyFilterChange({ productType: null, transaction_product_type_id: null })
    });
    if (filters.unit_monitored_by_id_selected) chips.push({
      key: 'monitored_by',
      label: `المراقب: ${filters.unit_monitored_by_id_selected.name || ''}`,
      onDelete: () => applyFilterChange({ unit_monitored_by_id_selected: null, unit_monitored_by_id: null })
    });
    if (filters.auditedByName) chips.push({
      key: 'audited_by',
      label: `المدقق: ${filters.auditedByName.name || filters.auditedByName}`,
      onDelete: () => applyFilterChange({ auditedByName: null, audited_by_id: null })
    });
    if (Array.isArray(filters.transaction_status_selected) && filters.transaction_status_selected.length > 0) {
      filters.transaction_status_selected.forEach((status) => {
        chips.push({
          key: `status_${status?.id}`,
          label: status?.name || '',
          onDelete: () => {
            const remaining = filters.transaction_status_selected.filter(s => s?.id !== status?.id);
            applyFilterChange({
              transaction_status_selected: remaining,
              transaction_status_ids: remaining.map(s => s.id)
            });
          }
        });
      });
    }
    if (Array.isArray(filters.branches_selected) && filters.branches_selected.length > 0) {
      filters.branches_selected.forEach((b) => {
        chips.push({
          key: `branch_${b?.id}`,
          label: `الفرع: ${b?.name || ''}`,
          onDelete: () => {
            const remaining = filters.branches_selected.filter(x => x?.id !== b?.id);
            applyFilterChange({
              branches_selected: remaining,
              branch_ids: remaining.map(x => x.id)
            });
          }
        });
      });
    }

    // ── Text filters ───────────────────────────────────────────────
    const textFilters = [
      { key: 'transaction_id', label: 'رقم المعاملة' },
      { key: 'transaction_number', label: 'رقم المستند' },
      { key: 'unit_registration_number', label: 'رقم اللوحة' },
      { key: 'driver_name', label: 'السائق' },
      { key: 'destination_warehouse', label: 'خزان الوصول' },
      { key: 'note', label: 'ملاحظة' },
      { key: 'carrier', label: 'الناقل' }
    ];
    textFilters.forEach(({ key, label }) => {
      const v = filters[key];
      if (v !== null && v !== undefined && String(v).trim() !== '') {
        chips.push({
          key,
          label: `${label}: ${v}`,
          onDelete: () => applyFilterChange({ [key]: '' })
        });
      }
    });

    // ── Net weight range (either bound may be open) ────────────────
    if (String(filters.min_weight ?? '').trim() !== '' || String(filters.max_weight ?? '').trim() !== '') {
      const minLabel = String(filters.min_weight ?? '').trim() !== '' ? filters.min_weight : '—';
      const maxLabel = String(filters.max_weight ?? '').trim() !== '' ? filters.max_weight : '—';
      chips.push({
        key: 'weight_range',
        label: `الوزن (طن): من ${minLabel} إلى ${maxLabel}`,
        onDelete: () => applyFilterChange({ min_weight: '', max_weight: '' })
      });
    }

    // ── Tri-state booleans (chip only when 0 or 1; -1 / null means "all") ─
    const triState = [
      { key: 'unit_is_monitored', on: 'مركبة مراقبة', off: 'مركبة غير مراقبة' },
      { key: 'is_monitored', on: 'مستند مراقب', off: 'مستند غير مراقب' },
      { key: 'has_violation', on: 'فيه مخالفة', off: 'بدون مخالفة' },
      { key: 'is_complete', on: 'مكتمل', off: 'غير مكتمل' },
      { key: 'exceeded_allowed_time', on: 'تجاوز الزمن المسموح', off: 'لم يتجاوز الزمن المسموح' },
      { key: 'has_stop_violation', on: 'يوجد توقف مخالف', off: 'بدون توقف مخالف' },
      { key: 'weight_problem', on: 'يوجد مشكلة بالوزن', off: 'بدون مشكلة بالوزن' },
      { key: 'destination_mismatch', on: 'اختلاف نقطة التفريغ', off: 'مطابقة نقطة التفريغ' },
      { key: 'valid', on: 'صالح', off: 'غير صالح' },
      { key: 'arrival_validity', on: 'وصل ضمن الفترة المسموحة', off: 'وصل خارج الفترة المسموحة' },
    ];
    triState.forEach(({ key, on, off }) => {
      const lbl = triStateLabel(filters[key], on, off);
      if (lbl) {
        chips.push({
          key,
          label: lbl,
          onDelete: () => applyFilterChange({ [key]: -1 })
        });
      }
    });

    if (filters.audited_by_type === 'system' || filters.audited_by_type === 'user') {
      chips.push({
        key: 'audited_by_type',
        label: `جهة التدقيق: ${filters.audited_by_type === 'system' ? 'النظام' : 'المستخدمين'}`,
        onDelete: () => applyFilterChange({ audited_by_type: 'all' })
      });
    }

    // ── Creation date range ────────────────────────────────────────
    const creationDefaultFrom = moment().subtract(1, 'day').startOf('day');
    const creationDefaultTo = moment().endOf('day');
    if (Number(filters.all_time) === 1) {
      chips.push({
        key: 'creation_all_time',
        label: 'الفترة: كل الوقت',
        onDelete: () => applyFilterChange({
          all_time: 0,
          creationDateFrom: yesterday,
          creationDateTo: todayEnd,
          creation_date_from: moment().subtract(1, "day").startOf("day").format('YYYY-MM-DD') + ' 00:00:00',
          creation_date_to: moment().endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
        })
      });
    } else if (filters.creation_date_from || filters.creation_date_to) {
      const fromLabel = filters.creation_date_from ? moment(filters.creation_date_from).format('YYYY-MM-DD') : '—';
      const toLabel = filters.creation_date_to ? moment(filters.creation_date_to).format('YYYY-MM-DD') : '—';
      const isDefault =
        filters.creation_date_from
        && filters.creation_date_to
        && moment(filters.creationDateFrom).isSame(creationDefaultFrom, 'day')
        && moment(filters.creationDateTo).isSame(creationDefaultTo, 'day');
      chips.push({
        key: 'creation_date',
        label: `الفترة: من ${fromLabel} إلى ${toLabel}`,
        onDelete: isDefault ? null : () => applyFilterChange({
          all_time: 0,
          creationDateFrom: yesterday,
          creationDateTo: todayEnd,
          creation_date_from: moment().subtract(1, "day").startOf("day").format('YYYY-MM-DD') + ' 00:00:00',
          creation_date_to: moment().endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
        })
      });
    }

    // ── Arrival date range (default is all_time_arrived_at = 1 → no chip) ─
    if (Number(filters.all_time_arrived_at) !== 1
        && (filters.arrived_at_date_from || filters.arrived_at_date_to
            || filters.arrived_at_from || filters.arrived_at_to)) {
      const fromVal = filters.arrived_at_date_from || filters.arrived_at_from;
      const toVal = filters.arrived_at_date_to || filters.arrived_at_to;
      const fromLabel = fromVal ? moment(fromVal).format('YYYY-MM-DD') : '—';
      const toLabel = toVal ? moment(toVal).format('YYYY-MM-DD') : '—';
      chips.push({
        key: 'arrived_at_range',
        label: `تاريخ الوصول: من ${fromLabel} إلى ${toLabel}`,
        onDelete: () => applyFilterChange({
          all_time_arrived_at: 1,
          arrivedAtFrom: yesterday,
          arrivedAtTo: todayEnd,
          arrived_at_from: moment().subtract(1, "day").startOf("day").format('YYYY-MM-DD') + ' 00:00:00',
          arrived_at_to: moment().endOf('day').format('YYYY-MM-DD') + ' 23:59:59',
          arrivedAtDateFrom: yesterday,
          arrivedAtDateTo: todayEnd,
          arrived_at_date_from: null,
          arrived_at_date_to: null
        })
      });
    }

    return chips;
  })();

  const downloadExcel = async (fileName) => {
    const result = await transactionAPI?.downloadExcel({
      params: {
        ...headerObject,
        fileName: fileName
      }
    })
    if (result.status && result?.data) {
      const url = window.URL.createObjectURL(new Blob([result?.data]));
      const link = document.createElement('a');
      link.href = url;
      
      let reportName = "مستندات الجهد الخارجي";
      if (filters.municipality && filters.municipality.name) {
        reportName += ` - ${filters.municipality.name}`;
      }
      reportName += ` - ${getExportDateSuffix()}`;

      link.setAttribute('download', reportName + '.xlsx');
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Clean up the URL object
      window.URL.revokeObjectURL(url);
    }
  }

  return (
    <Box
      sx={{

        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "start",
        overflowX: "hidden",
        "& .MuiChip-label": {
          fontFamily: "Cairo-Medium",
        },
      }}
    >
      {showStops ? (
        <TransactionStops

          object={selectedObject}
          openForm={showStops}
          setOpenForm={setShowStops}
          loadData={loadData}
        />
      ) : null}
      {showRoutes ? (
        <TransactionRoutes
          object={selectedObject}
          openForm={showRoutes}
          setOpenForm={setShowRoutes}
          loadData={loadData}
        />
      ) : null}
      {openForm ? (
        <FormContainer
          object={selectedObject}
          openForm={openForm}
          setOpenForm={setOpenForm}
          loadData={loadData}
        />
      ) : null}
      {openViewForm && selectedObject ? (
        <ViewFormContainer
          object={selectedObject}
          openForm={openViewForm}
          setOpenForm={setOpenViewForm}
        />
      ) : null}
      {openUpdateForm && selectedObject ? (
        <UpdateFormContainer
          object={selectedObject}
          openForm={openUpdateForm}
          setOpenForm={setOpenUpdateForm}
          loadData={loadData}
        />
      ) : null}
      {openAuditForm && selectedObject ? (
        <AuditFormContainer
          object={selectedObject}
          openForm={openAuditForm}
          setOpenForm={setOpenAuditForm}
          loadData={loadData}
        />
      ) : null}

      {ARRIVAL_VALIDITY_ENABLED ?
        <RecalcValidityDialog
          open={openRecalcValidity}
          setOpen={setOpenRecalcValidity}
          lifecycleType={1}
          lifecycleLabel={"مستندات الجهد الخارجي"}
          onDone={() => setReload(!reload)}
        />
      : null}

      <ArrivalDurationsModal
        open={openDurations}
        onClose={() => setOpenDurations(false)}
        filters={filters}
      />

      {openCreateRouteForm ? (
        <CreateRouteFormContainer
          object={true}
          transaction={selectedObject}
          objectType={"transaction"}
          openForm={openCreateRouteForm}
          setOpenForm={setOpenCreateRouteForm}
          loadData={loadData}
        />
      ) : null}

      <TransactionImagesModal
        open={showImagesModal}
        onClose={() => setShowImagesModal(false)}
        transactionId={selectedTransactionForImages}
        transactionDatetime={transactionDatetime}
      />

      {activeFilterChips.length > 0 && (
        <Box sx={{
          width: '100%',
          p: 1.5,
          mb: 1,
          borderRadius: 2,
          bgcolor: '#f8f9fa',
          border: '1px solid #e9ecef',
          display: 'flex',
          flexDirection: 'column',
          gap: 1
        }}>
          <Typography sx={{ fontFamily: 'Cairo-Medium', color: '#495057', fontSize: '0.9rem' }}>
            تصفية النتائج حسب هذه القيم
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'flex-start' }}>
            {activeFilterChips.map(chip => (
              <Chip
                key={chip.key}
                label={chip.label}
                {...(chip.onDelete ? { onDelete: chip.onDelete } : {})}
                variant="outlined"
                sx={{
                  fontFamily: 'Cairo-Medium',
                  borderColor: '#dc3545',
                  color: '#dc3545',
                  '& .MuiChip-deleteIcon': { color: '#dc3545' }
                }}
              />
            ))}
          </Box>
        </Box>
      )}

      <CustomDataGridWithSearch
        // <Grid
        setClickedCollapsed={setClickedCollapsed}
        viewFunction={viewFunction}
        exportReport={exportReport}
        createReport={createReport}
        showUpdate={showUpdate}
        UpdateFunction={UpdateFunction}
        auditFunction={auditFunction}
        createRouteFunction={createRouteFunction}
        showRoutesFunction={showRoutesFunction}
        showStopsFunction={showStopsFunction}
        showImagesFunction={showImagesFunction}
        checkArrivalFunction={checkArrivalFunction}
        resultSideButton={(
          <Tooltip title={<span style={{ fontFamily: "Cairo" }}>{t("ARRIVAL_VALIDITY_RULES.durations_button")}</span>}>
            <IconButton
              onClick={() => setOpenDurations(true)}
              sx={{
                bgcolor: "rgba(28,100,242,0.10)", color: "#1C64F2", borderRadius: "10px",
                width: 40, height: 40, transition: "all .2s",
                "&:hover": { bgcolor: "rgba(28,100,242,0.20)", transform: "scale(1.06)" },
              }}
            >
              <AccessTimeIcon />
            </IconButton>
          </Tooltip>
        )}
        recalcValidityFunction={ARRIVAL_VALIDITY_ENABLED && rolesRedux?.add_transaction_audit?.value ? recalcValidityFunction : undefined}
        revertValidityFunction={ARRIVAL_VALIDITY_ENABLED && rolesRedux?.add_transaction_audit?.value ? revertValidityFunction : undefined}
        rows={rows}
        setRows={setRows}
        multipleExports={[
          { icon: <SiMicrosoftexcel color="green" size={"25"} />, name: t('TRANSACTIONS.exportExcel') || 'تصدير Excel', key: 'tc_excel', onClick: () => { exportFunction() } },
          { icon: <BsFilePdfFill color="red" size={"25"} />, name: t('TRANSACTIONS.exportPDF') || 'تصدير PDF', key: 'tc_pdf', onClick: () => { exportPDF() } }
        ]}
        fixHeight={'calc(100vh - 300px)'}
        getRowClassName={getRowClassName}
        hasExport={false}
        columns={columns}
        pageSize={pageSize}
        setPageSize={setPageSize}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        loading={loading}
        handlePageChange={handlePageChange}
        rowsTotal={rowsTotal}
        totalWeight={totalWeight}
        checkScreenSize={screenwidth}
        pageCount={pageCount}
        openFilterColumn={openFilterColumn}
        elementClicked={elementClicked}
        setOpenFilterColumn={setOpenFilterColumn}
        setColumnFilterValue={setOpenFilterColumnValue}
        columFilterValue={openFilterColumnValue}
        clearFunction={clearFilterFunction}
        searchFunction={searchFunction}
        hasCreate={false}
        creatFunction={createFunction}
        hasColumnsHidShow={true}
        setColumns={setColumns}
        LeftHeaderComponent={
          <Title
            createFunction={createFunction}
            openFilterColumn={openFilterColumn}
            reload={reload}
            setReload={(value) => {
              setReload(value)
            }}
            fast={fast}
            setFast={setFast}
            mainTitle={"مستندات الجهد الخارجي"}
            showReprocessWrongTypeButton={true}
            handleReprocessWrongType={handleReprocessWrongType}
            showRecalcValidityButton={ARRIVAL_VALIDITY_ENABLED && rolesRedux?.add_transaction_audit?.value}
            handleRecalcValidity={() => setOpenRecalcValidity(true)}
            loading={loading}
          />
        }
        filterChilds={
          <Search
            filters={filters}
            setFilters={setFilters}
            loadingBranches={loadingBranches}
            branches={branches}
            loadingPortCategories={loadingPortCategories}
            portCategories={portCategories}
            groups={groups}
            loadingGroups={loadingGroups}
            transactionStatuses={transactionStatuses}
            loadingTransactionStatuses={loadingTransactionStatuses}
            users={users}
            loadingUsers={loadingUsers}
            transactionType2List={transactionType2List}
            loadingTransactionType2List={loadingTransactionType2List}
            transactionProductTypes={transactionProductTypes}
            loadingTransactionProductTypes={loadingTransactionProductTypes}
            municipalities={municipalities}
            loadingMunicipalities={loadingMunicipalities}
            showWeightRange={true}
            isVisible={filterIsVisible}
          />
        }
      />

    </Box>
  );
}
